/*
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import moment from 'moment';

import clusterTemplate from './cluster.html';
import './cluster.css';

class ClusterController {
  constructor() {
    'ngInject';

    if (this.hasHealth()) {
      const health = this.cluster.health;
      this.instances = [health.driver].concat(health.workers);
    } else {
      this.instances = [];
    }
  }

  getCluster() {
    return this.cluster;
  }

  getDescription() {
    return this.cluster.description;
  }

  getSparkUiAddress() {
    return this.cluster.sparkUiAddress;
  }

  hasWorkers() {
    return this.cluster.workerCount > 0;
  }

  hasHealth() {
    return !_.isUndefined(this.cluster.health);
  }

  getInstances() {
    return this.instances;
  }

  getLastActivity(timestamp) {
    if (timestamp) {
      return moment.utc(timestamp).fromNow();
    } else {
      return 'Never';
    }
  }

  getFooter() {
    const lastStarted = this.getLastActivity(this.cluster.lastStarted);
    const lastStopped = this.getLastActivity(this.cluster.lastStopped);
    return `Last Started: ${lastStarted}, Last Stopped: ${lastStopped}`;
  }

  isCurrent() {
    return this.current;
  }

  isRunning() {
    return this.cluster.state === 'Running';
  }

  setCurrent(current) {
    if (current) {
      this.setCurrentCluster(this.cluster);
    } else {
      this.setCurrentCluster();
    }
  }

  isSettingCurrentCluster() {
    return this.settingCurrentCluster;
  }
}

export const ClusterComponent = {
  bindings: {
    cluster: '<',
    current: '<',
    setCurrentCluster: '=',
    settingCurrentCluster: '<',
  },
  template: clusterTemplate,
  controller: ClusterController,
};

export const ClusterModule = angular
  .module('zeppelinWebApp')
  .component('cluster', ClusterComponent)
  .name;



// WEBPACK FOOTER //
// ./src/app/clusters/cluster/cluster.component.js